import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {Text, TextVariant} from '@/components/common/content/Text'
import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {TeamCarousel} from '@/components/common/team/TeamCarousel'
import {TeamMember} from '@/components/common/team/TeamMember'
import {getAboutUsContent} from '@/content/aboutUs'
import {TeamMemberType} from '@/content/team'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type TeamNavigationProps = {
  team: TeamMemberType[]
}

export const TeamNavigation: FC<TeamNavigationProps> = ({team}) => {
  const {t} = useTranslation()
  const {title, buttonText, buttonLinkHref} = getAboutUsContent().profilePage.navigation

  return (
    <>
      <div className="wrapper">
        <div>
          <Text variant={TextVariant.h2}>{t(title)}</Text>
          <div className="button-wrapper">
            <Link href={buttonLinkHref}>
              <Button type="button" icon={<ArrowIcon />} isHoverable>
                {t(buttonText)}
              </Button>
            </Link>
          </div>
        </div>
        <div className="team desktop">
          {team.map((teamMember) => (
            <div key={teamMember.name} className="team-member">
              <TeamMember teamMember={teamMember} size="small" />
            </div>
          ))}
        </div>
        <div className="mobile">
          <TeamCarousel teamMembers={team} />
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          justify-content: space-between;
          margin: 0 -${theme.spacing[3]};
        }
        .button-wrapper {
          margin-top: ${theme.spacing[3]};
        }
        .team {
          display: flex;
          margin-left: ${theme.spacing[6]};
        }
        .team-member {
          width: 200px;
        }
        .team-member + .team-member {
          margin-left: ${theme.spacing[4]};
        }
        .mobile {
          display: none;
        }
        @media ${TABLET_SCREENSIZE} {
          .wrapper {
            display: block;
            text-align: center;
            margin: 0;
          }
          .team {
            margin-left: 0;
            margin-top: ${theme.spacing[6]};
            justify-content: center;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .desktop {
            display: none;
          }
          .mobile {
            display: block;
          }
        }
      `}</style>
    </>
  )
}
